import { useState } from 'react';
import {
    Collapse,
    Col,
    Row,
} from 'reactstrap';

import CarbonEmissions from './report/CarbonEmissions';
import Certifications from './report/Certifications';
import Documents from './report/Documents';
import EmissionReductionTargets from './report/EmissionReductionTargets';
import OtherKeyFigures from './report/OtherKeyFigures';

const EsgReport = ({
    t,
    report,
}) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <>
            <button
                type="button"
                className="overview-esg-rating__toggle"
                onClick={() => setIsOpen((open) => !open)}
            >
                <span>{t('ESG Report')}</span>
                <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line`} />
            </button>

            <Collapse isOpen={isOpen}>
                <Row className="g-3 pt-3">
                    <Col xs="12" lg="8">
                        <div className="overview-esg-rating__report-panel">
                            <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
                                <div>
                                    <p className="overview-esg-rating__report-title mb-1">
                                        {report?.title}
                                    </p>
                                    <p className="overview-esg-rating__caption mb-0">
                                        {report?.meta}
                                    </p>
                                </div>
                                {report?.url && (
                                    <a
                                        href={report.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="overview-esg-rating__link flex-shrink-0"
                                    >
                                        {t('View Report')} ↗
                                    </a>
                                )}
                            </div>

                            <CarbonEmissions
                                t={t}
                                emissions={report?.carbonEmissions}
                            />
                            <EmissionReductionTargets
                                t={t}
                                targets={report?.targets}
                            />
                            <OtherKeyFigures
                                t={t}
                                figures={report?.keyFigures}
                            />
                        </div>
                    </Col>

                    <Col xs="12" lg="4">
                        <Documents
                            t={t}
                            documents={report?.documents}
                            documentsUrl={report?.documentsUrl}
                        />
                        <Certifications
                            t={t}
                            certifications={report?.certifications}
                        />
                    </Col>
                </Row>
            </Collapse>
        </>
    );
};

export default EsgReport;
